// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"71ba932d","787":"0a5f7a21"}[chunkId] + ".chunk.js";
};